import React from 'react';

import {
  ActionButton,
  Actions,
  CheckIcon,
  Container,
  Info,
  SelectionCount,
  Text,
  TotalLabel,
  TotalPrefixDesktop,
  TotalPrefixMobile,
} from './styles';

export type SelectionBarProps = {
  selectedCount: number;
  totalLabel: string;
  onSendEmail?: () => void;
  onDownload?: () => void;
  sendEmailLabel?: string;
  downloadLabel?: string;
  itemLabelSingular?: string;
  itemLabelPlural?: string;
  selectionText?: string;
  disabled?: boolean;
  className?: string;
};

const SelectionCheckIcon = (): JSX.Element => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 6L5 8.5L9.5 3.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SelectionBar = ({
  selectedCount,
  totalLabel,
  onSendEmail,
  onDownload,
  sendEmailLabel = 'Enviar 2ª via por e-mail',
  downloadLabel = 'Baixar 2ª via',
  itemLabelSingular = 'boleto',
  itemLabelPlural = 'boletos',
  selectionText,
  disabled = false,
  className,
}: SelectionBarProps): JSX.Element => {
  const itemLabel = selectedCount === 1 ? itemLabelSingular : itemLabelPlural;

  return (
    <Container className={className}>
      <Info>
        <CheckIcon aria-hidden="true">
          <SelectionCheckIcon />
        </CheckIcon>
        <Text>
          <SelectionCount>
            {selectionText ||
              `${selectedCount} ${itemLabel} selecionado${
                selectedCount === 1 ? '' : 's'
              }`}
          </SelectionCount>
          <TotalLabel>
            <TotalPrefixDesktop>total: </TotalPrefixDesktop>
            <TotalPrefixMobile>Valor total: </TotalPrefixMobile>
            {totalLabel}
          </TotalLabel>
        </Text>
      </Info>

      <Actions>
        <ActionButton
          type="button"
          $variant="outline"
          disabled={disabled}
          onClick={onSendEmail}
        >
          {sendEmailLabel}
        </ActionButton>
        <ActionButton
          type="button"
          $variant="solid"
          disabled={disabled}
          onClick={onDownload}
        >
          {downloadLabel}
        </ActionButton>
      </Actions>
    </Container>
  );
};

export default SelectionBar;
